import Text18 from './Text18'
export default Text18
